import { fillString } from '@local_modules/generic/string-template.js'
import { callApi } from '@local_modules/generic/fetch.js'
import { loadDataAlaSQL } from './alasql.js'
import { enrichLoadedData } from './enrich-loaded-data.js'
import { LOADED_DATA } from './cache-loaded-data.js'
import { targetCurrencySymbol } from './target-currency-symbol.js'

export async function loadEliminations (context) {
  // console.log('loadEliminations', context, context.includedEntityIds)

  if (context.includedEntityIds.length <= 1) return

  const realEntityIds = context.includedEntityIds.filter(entityId => entityId !== 'eliminations')
  const urlAccountingOrganisationIds = realEntityIds.sort().join(',')

  const currencyCode = targetCurrencySymbol(context, 'eliminations')

  const apiEndpoint = '/api/pg-financials/data/:appAccountId/eliminations/:accountingOrganisationIds/:monthFrom/:monthTo/:currencyCode'
  const url = fillString(apiEndpoint, {
    appAccountId: context.browserAppAccount.data.appAccountId,
    accountingOrganisationIds: urlAccountingOrganisationIds,
    monthFrom: context.dates?.min,
    monthTo: context.dates?.max,
    currencyCode
  })

  if (LOADED_DATA.has(url)) {
    return LOADED_DATA.get(url)
  }

  const eliminationsResponse = await callApi(url)
  console.log('eliminationsResponse', eliminationsResponse)
  LOADED_DATA.set(url, eliminationsResponse)

  enrichLoadedData(eliminationsResponse.chartOfAccounts, eliminationsResponse.eliminations)
  loadDataAlaSQL(eliminationsResponse.eliminations)

  return eliminationsResponse
}
